<template>
  <div>
    <Header />
    <span class="back-meal-vue" @click="backHistory">＜ 戻る</span>
    <div class="date">
      <span class="parenthesis" @click="getOneWeek(-1)">＜</span>
      <span class="day">{{ startDate }}〜{{ endDate }}</span>
      <span v-show="isActive" class="parenthesis" @click="getOneWeek(1)">＞</span>
    </div>

    <table>
      <tr class="week-day">
        <th class="color-gray" width="60" colspan="2"></th>
        <th v-for="weekDay in weekDays" class="color-orange" :key="weekDay.day">{{ weekDay.day }}<br />{{ weekDay.week }}</th>
        <th class="color-gray total-score">合<br />計</th>
      </tr>

      <tr class="staple-food">
        <td class="carbohydrate" colspan="2">炭水化物</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.rice ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:riceAlertColor }">{{ riceCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">肉類</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.meal ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:mealAlertColor }">{{ mealCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">魚介類</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.fish ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:fishAlertColor }">{{ fishCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">卵</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.egg ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:eggAlertColor }">{{ eggCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">大豆製品</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.soy ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:soyAlertColor }">{{ soyCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">牛乳・乳製品</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.milk ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:milkAlertColor }">{{ milkCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">海藻類</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.seaweed ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:seaweedAlertColor }">{{ seaweedCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">緑黄色野菜</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.vegetables ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:vegetablesAlertColor }">{{ vegetablesCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">果物</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.fruit ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:fruitAlertColor }">{{ fruitCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">いも類</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.potato ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:potatoAlertColor }">{{ potatoCount }}</td>
      </tr>

      <tr class="side-dish">
        <td class="name" colspan="2">油脂類</td>
        <td class="right-color" v-for="item in weekDays" v-bind:class="{ changebackcolor:item.goalAchievement }">{{ item.oil ? "◯" : "" }}</td>
        <td v-bind:class="{ changecolor:oilAlertColor }">{{ oilCount }}</td>
      </tr>

      <tr class="food-total-score">
        <td rowspan="2" class="color-sunken-gray">合計</td>
        <td class="color-gray">主食</td>
        <td v-for="item in weekDays" v-bind:class="{ changecolor:item.mainDishAlertColor, changebackcolor:item.goalAchievement }">{{ item.rice ? "1" : "0" }}</td>
        <td rowspan="2" class="color-gray"></td>
      </tr>

      <tr>
        <td class="color-gray">副食</td>
        <td v-for="item in weekDays" v-bind:class="{ changecolor:item.sideDishAlertColor, changebackcolor:item.goalAchievement }">{{ item.side_dish }}</td>
      </tr>
    </table>
    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "WeeklyTable",
  components: {
    Header,Footer
  },
  beforeDestroy() {
    document.body.className = "";
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      weekStart: "",
      thisWeekStart: "",
      isActive: false,
      Week: 0,
      riceCount: 0,mealCount: 0,fishCount: 0,eggCount: 0,soyCount: 0,milkCount: 0,seaweedCount: 0,vegetablesCount: 0,fruitCount: 0,potatoCount: 0,oilCount: 0,
      riceAlertColor: true,mealAlertColor: true,fishAlertColor: true,eggAlertColor: true,soyAlertColor: true,milkAlertColor: true,seaweedAlertColor: true,vegetablesAlertColor: true,fruitAlertColor: true,potatoAlertColor: true,oilAlertColor: true,
      oneMonthMealRecord: [],
      weekDays: [
        { week: "月", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false},
        { week: "火", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false },
        { week: "水", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false },
        { week: "木", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false },
        { week: "金", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false },
        { week: "土", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false},
        { week: "日", day: "", rice: "", meal: "", fish: "", egg: "", soy: "", milk: "", seaweed: "", vegetables: "", fruit: "", potato: "", oil: "", side_dish: 0, mainDishAlertColor: true, sideDishAlertColor: true, goalAchievement: false },
      ],
    };
  },
  created() {
    this.getThisWeek();
  },
  mounted() {
    document.body.className = "back-color";
    this.thisWeekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
    this.oneMonthMealRecord = this.$store.state.oneMonthMealRecord;
    this.createWeeklyTable(this.thisWeekStart);
  },
  methods: {
    getThisWeek() {
      //今週初
      this.startDate = moment().startOf("isoWeek").format("MM-DD");
      //今週末
      this.endDate = moment().endOf("isoWeek").format("MM-DD");
      //今日の日付
      this.weekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
      this.setDateOfWeek(this.weekStart);
    },
    getOneWeek(value) {
      this.isActive = true
      this.Week = this.Week + value;
      this.startDate = moment().add("isoWeek", this.Week).startOf("isoWeek").format("MM-DD");
      this.endDate = moment().add("isoWeek", this.Week).endOf("isoWeek").format("MM-DD");
      this.weekStart = moment().add("isoWeek", this.Week).startOf("isoWeek").format("YYYY-MM-DD");
      if(this.weekStart === this.thisWeekStart) this.isActive = false
      this.setDateOfWeek(this.weekStart);
      this.foodsTotalCountClear();
      this.createWeeklyTable(this.weekStart);
    },
    setDateOfWeek(startWeek) {
      this.index = 0;
      for (let i = 0; i < 7; i++) {
        this.weekDays[this.index].day = moment(startWeek).add(i, "days").format("DD");
        this.index++;
      }
    },
    createWeeklyTable(weekStart) {
      const len = Object.keys(this.oneMonthMealRecord).length;
      for (let i = 0; i < 7; i++) {
        const targetWeekDays = moment(weekStart).add(i, "days").format("YYYY-MM-DD");
        for (let n = 0; n < len; n++) {
          if (this.oneMonthMealRecord[n].date === targetWeekDays) {
            this.weekDays[i].rice = this.oneMonthMealRecord[n].staple_food["1"];
            if (this.weekDays[i].rice === true) {
              this.riceCount++;
              this.riceAlertColor = false
              this.weekDays[i].mainDishAlertColor = false
            }
            this.weekDays[i].meal = this.oneMonthMealRecord[n].side_dish["2"];
            if (this.weekDays[i].meal === true) {
              this.mealCount++;
              this.weekDays[i].side_dish++;
              this.mealAlertColor = false
            }
            this.weekDays[i].fish = this.oneMonthMealRecord[n].side_dish["3"];
            if (this.weekDays[i].fish === true) {
              this.fishCount++;
              this.weekDays[i].side_dish++;
              this.fishAlertColor = false
            }
            this.weekDays[i].egg = this.oneMonthMealRecord[n].side_dish["4"];
            if (this.weekDays[i].egg === true) {
              this.eggCount++;
              this.weekDays[i].side_dish++;
              this.eggAlertColor = false
            }
            this.weekDays[i].soy = this.oneMonthMealRecord[n].side_dish["5"];
            if (this.weekDays[i].soy === true) {
              this.soyCount++;
              this.weekDays[i].side_dish++;
              this.soyAlertColor = false
            }
            this.weekDays[i].milk = this.oneMonthMealRecord[n].side_dish["6"];
            if (this.weekDays[i].milk === true) {
              this.milkCount++;
              this.weekDays[i].side_dish++;
              this.milkAlertColor = false
            }
            this.weekDays[i].seaweed = this.oneMonthMealRecord[n].side_dish["7"];
            if (this.weekDays[i].seaweed === true) {
              this.seaweedCount++;
              this.weekDays[i].side_dish++;
              this.seaweedAlertColor = false
            }
            this.weekDays[i].vegetables = this.oneMonthMealRecord[n].side_dish["8"];
            if (this.weekDays[i].vegetables === true) {
              this.vegetablesCount++;
              this.weekDays[i].side_dish++;
              this.vegetablesAlertColor = false
            }
            this.weekDays[i].fruit = this.oneMonthMealRecord[n].side_dish["9"];
            if (this.weekDays[i].fruit === true) {
              this.fruitCount++;
              this.weekDays[i].side_dish++;
              this.fruitAlertColor = false
            }
            this.weekDays[i].potato = this.oneMonthMealRecord[n].side_dish["10"];
            if (this.weekDays[i].potato === true) {
              this.potatoCount++;
              this.weekDays[i].side_dish++;
              this.potatoAlertColor = false
            }
            this.weekDays[i].oil = this.oneMonthMealRecord[n].side_dish["11"];
            if (this.weekDays[i].oil === true) {
              this.oilCount++;
              this.weekDays[i].side_dish++;
              this.oilAlertColor = false
            }
          }
        }
        if(this.weekDays[i].side_dish > 3) {
          this.weekDays[i].sideDishAlertColor = false
        }
        if(this.weekDays[i].rice === true && this.weekDays[i].side_dish > 6) {
          this.weekDays[i].goalAchievement = true
        }

      }
    },
    foodsTotalCountClear() {
      this.riceCount = 0;this.mealCount = 0;this.fishCount = 0;this.eggCount = 0;this.soyCount = 0;this.milkCount = 0;this.seaweedCount = 0;
      this.riceAlertColor = true; this.mealAlertColor = true; this.fishAlertColor = true; this.eggAlertColor = true; this.soyAlertColor = true; this.milkAlertColor = true; this.seaweedAlertColor = true; this.vegetablesAlertColor = true; this.fruitAlertColor = true; this.potatoAlertColor = true; this.oilAlertColor = true,
      this.vegetablesCount = 0;this.fruitCount = 0;this.potatoCount = 0;this.oilCount = 0;
      for (const items in this.weekDays) {
        this.weekDays[items].rice = "";
        this.weekDays[items].meal = "";
        this.weekDays[items].fish = "";
        this.weekDays[items].egg = "";
        this.weekDays[items].soy = "";
        this.weekDays[items].milk = "";
        this.weekDays[items].seaweed = "";
        this.weekDays[items].vegetables = "";
        this.weekDays[items].fruit = "";
        this.weekDays[items].potato = "";
        this.weekDays[items].oil = "";
        this.weekDays[items].side_dish = 0;
        this.weekDays[items].mainDishAlertColor = true;
        this.weekDays[items].sideDishAlertColor = true;
        this.weekDays[items].goalAchievement = false;
      }
    },
    backHistory() {
      this.$router.push({name: 'History', params: {propsSelected: true}});
    },
  },
};
</script>

<style scoped>
.back-meal-vue {
  position: absolute;
  top: 1%;
  left: 3%;
  color: #fff;
  font-weight: 600;
}
.date {
  margin-top: 2%;
  margin-bottom: 5%;
  font-size: 1.7rem;
}
.date .day {
  margin: 0 15%;
  font-family: monospace;
}
.date .parenthesis {
  color: #00a0b9;
  font-weight: bold;
}
table {
  width: 95%;
  margin: 3% auto;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;
}
table tr td {
  /* border: 1px solid #aaa; */
  border-bottom: 1px solid #aaa;
  border-right: 1px solid #aaa;
  font-weight: 500;
}

table .color-gray {
  background-color: #cccccc;
}
table .color-orange {
  background-color: orange;
  color: white;
  width: 9%;
}
table .total-score {
  width: 9%;
}
table .staple-food .carbohydrate {
  color: #00a0b9;
  background-color: #d3edfb;
  padding: 1% 0;
}
table .side-dish .name {
  background-color: #00a0b9;
  color: white;
  padding: 1% 0;
}
table .food-total-score .color-sunken-gray {
  background-color: #bdbdbd;
}
.right-color {
  color: #00a0b9;
  font-weight: bold;
}
.changecolor {
  color: red;
}
.changebackcolor {
  background-color: #ff8a0024;
}


@media screen and (max-width:375px) and (max-height: 667px) { 
  .date {
  margin-top: 1%;
  margin-bottom: 2%;
  font-size: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WeeklyTable.vue